@if (content$ | async; as content) {
  <div>
    <div class="cancel-container">
      <c11n-button [variant]="quitButtonVariant" [labelText]="content.linkText" fullWidth="true" (clickEvent)="openQuitModal()">
      </c11n-button>
    </div>
    <c11n-modal-dialog #quitModal modalId="quit" [headingText]="content.modalHeader" maxWidth="500"
      (closeEvent)="closeQuitModalIcon()">
      <div c11n-modal-dialog-body>
        <div class="c11n-modal-dialog__content__buttons">
          <c11n-button [labelText]="content.yes" (clickEvent)="yesQuitButton()" data-btn="dialog-content-button">
          </c11n-button>
          <c11n-button [labelText]="content.no" variant="secondary" (clickEvent)="closeQuitModalButton()"
            data-btn="dialog-content-button">
          </c11n-button>
        </div>
      </div>
    </c11n-modal-dialog>
  </div>
}
